import React, { useCallback, useEffect, useState } from 'react';
import L from 'leaflet';
import { Map, Marker, TileLayer } from "react-leaflet";
import "react-leaflet-markercluster/dist/styles.min.css";
import Spinner from '../../components/Spinner';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

const FindLocationMap = ({ handleFindLocationChange, handleCancel }) => {
  const { t } = useTranslation();
  const [zoom, setZoom] = useState();
  const [centerCoors, setCenterCoors] = useState({
    lat: 21.028511,
    lng: 105.804817,
  });

  useEffect(() => {
    setZoom(8)
  }, [])

  const renderMap = useCallback(() => {
    const HoangSaMarker = new L.Icon({
      iconUrl: process.env.PUBLIC_URL + '/icons/hoang_sa.svg',
      iconRetinaUrl: process.env.PUBLIC_URL + '/icons/hoang_sa.svg',
      iconAnchor: null,
      shadowUrl: null,
      shadowSize: null,
      shadowAnchor: null,
      iconSize: new L.Point(50, 50),
    });

    const TruongSaMarker = new L.Icon({
      iconUrl: process.env.PUBLIC_URL + '/icons/truong_sa.svg',
      iconRetinaUrl: process.env.PUBLIC_URL + '/icons/truong_sa.svg',
      iconAnchor: null,
      shadowUrl: null,
      shadowSize: null,
      shadowAnchor: null,
      iconSize: new L.Point(60, 60),
    });
    return (
      <Map
        className="find-location-map"
        zoom={zoom}
        center={centerCoors}
        onclick={(e) => {
          handleFindLocationChange(e?.latlng);
          handleCancel();
          message.success(t('Add lat lng successfully'));
        }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url={`https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png?key=cb1_29qr_1_c0df2ae1e7a7e6440cbe3e3c`}
        />
        <Marker
          position={[16.103525, 111.919686]}
          icon={HoangSaMarker}
        ></Marker>
        <Marker
          position={[8.644641, 111.919686]}
          icon={TruongSaMarker}
        ></Marker>
      </Map>
    )
  }, [centerCoors, handleCancel, handleFindLocationChange, t, zoom]);
  return zoom ? renderMap() : <Spinner />;
};

export default FindLocationMap;
